import { FieldArrayRenderProps, useField } from "formik";
import { FrequencyArray, InvestmentFundType } from "../../../redux-store/types/api-types";
import { MandateListItem, MandatesListResBody } from "../../../redux-store/types/investorProfile";
import { Box, CircularProgress, Grid, Hidden, IconButton, Skeleton, Tab, Theme, Typography, useTheme } from "@mui/material";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useState } from "react";
import { RootStateType } from "../../../redux-store/reducers";
import { checkImageExists, formatCurrency } from "../../../utils/utilityFunctions";
import { DeleteIcons } from "../../../assets/SvgIcons";
import AlertModel from "../common/AlertModel";
import AddBankModal from "../common/AddBankModal";
import Lumpsum from "./Lumpsum"
import Sip from "./Sip";
import { TabContext, TabList } from "@mui/lab";
import { isArray } from "lodash";
import { setCheckedHoldingSchemes, setSelectedAllHoldingsInfo, setSelectedHoldingsInfo } from "../../../redux-store/actions/investorProfile";
import { ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD, MPOWER_ACCOUNT_TYPE_MASTER, USER_ROLES } from "../../../utils/constant";
import { GetOrderEntryBanksListResponseBody } from "../../../redux-store/types/orderManagement";

interface CardProps {
    isLoading: boolean;
    // data: InvestmentFundType;
    id: string | number;
    arrayhelper: FieldArrayRenderProps,
    handleDelete: (id: number | string, folio?: string, selectedUniqueId?: string) => void,
    clientCode?: string,
    activeMandateList: Array<MandateListItem>
    folio: { folioId: string, schemeId: string, marketValue: string, investedValue: string, id: string }[]
    selectedSchemes: string[]
    isSubmitting: boolean;
    bankAccountList?: GetOrderEntryBanksListResponseBody;
    isBankBalanceObjLoading?: boolean
}


// Array Card
const Card = (props: CardProps) => {
    const { isLoading, id, //data,
        arrayhelper, handleDelete, clientCode, activeMandateList, folio, selectedSchemes, isSubmitting, bankAccountList, isBankBalanceObjLoading = false } = props;
    const { form: { values, resetForm, setValues, errors, setErrors, setTouched } } = arrayhelper

    const dispatch = useDispatch()
    const { palette } = useTheme();
    const history = useHistory();
    const { pathname } = history.location
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    const {
        selectAllHoldingsInfo,
        selectedHoldingsInfo
    } = useSelector((store: RootStateType) => store.investorProfile);
    const {
        role = '',
    } = useSelector((store: RootStateType) => store.auth);
    const {
        selectedPortfolioObj
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);


    const [tabList] = useState(['Lumpsum', 'SIP']);
    const [open, setOpen] = useState(false);
    const [openBankModal, setOpenBankModal] = useState(false);

    const [field, meta, helpers] = useField(`fund[${id}].activeTab`);

    const filterFolio = folio?.[id as number]

    const isInvestMore = pathname.split('/')[pathname.split('/').length - 1] === 'invest-more'

    const handleSuccess = () => {
        // console.log('success')
        field.onChange(tabList[1])
    }


    const handleClose = useCallback(() => {
        setOpen(false)
    }, [])

    const handleBankClose = useCallback(() => {
        setOpenBankModal(false)
    }, [])

    const handleDeleteCardValue = (scheme: string, selectedUniqueId?: string) => {
        if (isInvestMore) {
            // const modifiedSelectedHoldingsInfo = selectedHoldingsInfo.filter(({ checkedId }) => checkedId !== scheme)
            // const modifiedSelectedAllHoldingsInfo = selectAllHoldingsInfo.filter(({ id: checkedId }) => checkedId !== id)

            const modifiedSelectedHoldingsInfo = selectedHoldingsInfo.filter(({ uniqueId }) => (uniqueId !== selectedUniqueId))
            const modifiedSelectedAllHoldingsInfo = selectAllHoldingsInfo.filter(({ uniqueId }) => (uniqueId !== selectedUniqueId))

            dispatch(setSelectedHoldingsInfo([...modifiedSelectedHoldingsInfo]))
            dispatch(setSelectedAllHoldingsInfo([...modifiedSelectedAllHoldingsInfo]))

            history.replace({
                state: ({
                    selectedSchemes: [...modifiedSelectedAllHoldingsInfo],
                    clientCode,
                    schemeDetails: modifiedSelectedAllHoldingsInfo?.map((obj) => ({
                        scheme_id: obj?.schemeId ?? "-",
                        isReinvestment: obj?.isReinvest ?? "-"
                    })),
                    folio: [...modifiedSelectedHoldingsInfo],
                })
            })

            const newValues = values.fund.filter((item: any) => {
                return (item?.uniqueId !== selectedUniqueId)
            })

            resetForm({
                values: {
                    fund: newValues,
                    ...((
                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                        ![USER_ROLES.INVESTOR].includes(role) &&
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        documents: values?.documents ?? []
                    } : {}),
                    ...((
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        bankAccountNumber: values?.bankAccountNumber ?? ""
                    } : {})
                }
            })
            const folioId = folio[id as number]

            handleDelete(scheme, folioId?.id, selectedUniqueId)

        } else {
            const newValues = values.fund.filter((item: any) => {
                return isInvestMore ? item?.folio?.id !== scheme : item?.schemeId !== scheme
            })

            resetForm({
                values: {
                    fund: newValues,
                    ...((
                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                        ![USER_ROLES.INVESTOR].includes(role) &&
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        documents: values?.documents ?? []
                    } : {}),
                    ...((
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        bankAccountNumber: values?.bankAccountNumber ?? ""
                    } : {})
                }
            })
            const folioId = folio[id as number]



            handleDelete(scheme, folioId?.id)
        }
    }

    const investmentList = (pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more') ? [
        {
            title: values.fund[id]?.detailsList?.[0]?.title || 'Aum',
            value: Number(values.fund[id]?.detailsList?.[0]?.value) ? formatCurrency({ value: Number(values.fund[id]?.detailsList?.[0]?.value), locale, currencyCode }) : "-",
        },
        {
            title: values.fund[id]?.detailsList?.[1]?.title || "NAV: -",
            value: Number(values.fund[id]?.detailsList?.[1]?.value) ? formatCurrency({ value: Number(values.fund[id]?.detailsList?.[1]?.value), locale, currencyCode }) : "-",
        },
        {
            title: values.fund[id]?.detailsList?.[2]?.title || "Invested Value",
            value: Number(values.fund[id]?.detailsList?.[2]?.value).toFixed(2) + '%' || "-",
        },
        {
            title: values.fund[id]?.detailsList?.[3]?.title || "Market Value",
            value: values.fund[id]?.detailsList?.[3]?.value || "-",
        }
    ] : [
        {
            title: 'Folio',
            value: filterFolio?.folioId || "-",
        },
        {
            title: values.fund[id]?.detailsList?.[1]?.title || "NAV: -",
            value: Number(values.fund[id]?.detailsList?.[1]?.value) ? formatCurrency({ value: Number(values.fund[id]?.detailsList?.[1]?.value), locale, currencyCode }) : "-",
        },
        {
            title: "Invested Value",
            value: Number(filterFolio?.investedValue) ? formatCurrency({ value: Number(filterFolio?.investedValue), locale, currencyCode }) : "-",
        },
        {
            title: "Market Value",
            value: Number(filterFolio?.marketValue) ? formatCurrency({ value: Number(filterFolio?.marketValue), locale, currencyCode }) : "-",
        },
    ]

    const amcIds = ['BDOTR', 'BPIAMC']

    const checkAmcId = amcIds.includes(values.fund[id].fundAmcId ?? '') ? values.fund[id].fundAmcId?.toLowerCase() : values.fund[id].fundAmcId;

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        const current = { ...values }
        // const currentError = { ...errors }
        current.fund[id].activeTab = newValue
        if (newValue === tabList[0]) {
            current.fund[id].sip = {
                sipamount: '',
                periods: values.fund[id]?.frequencies?.filter((freq: any) => freq.tranasactionType === 'SIP')[0]?.frequency || '',
                installments: '',
                sipDate: '',
                endDate: '',
                mandate: values.fund[id]?.mandate[0]?.mandateId || '',
                firstOrder: true,
                sipUntilCancelFlag: false,
                sipFolio: values.fund[id]?.folios?.availableFolios[0] || '',
            }
        } else {
            current.fund[id].lumpsum = {
                lumpAmount: '',
                lumpsumFolio: values.fund[id]?.folios?.availableFolios[0] || '',
            }
        }

        setValues(current)
    };

    return (
        <Box
            sx={{
                background: palette.background.paper,
                boxShadow: 1,
                borderRadius: '20px',
                padding: '35px 30px',
                display: 'flex',
                flexDirection: 'column',
                gap: { lg: '35px', md: '35px', sm: '25px', xs: '25px' },
                border: `3px solid ${palette.stroke.main}`
            }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    // flexWrap: 'wrap',
                }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'row',
                        gap: '15px',
                        overflow: 'hidden', // Ensure overflow is hidden for the parent
                        width: '100%',
                    }}>
                    {isLoading ? (
                        <CircularProgress />
                    ) : (
                        <img
                            src={checkImageExists(`${checkAmcId}`) ? `/images/amcIcons/${checkAmcId}.svg` : `/images/amcIcons/default.svg`}
                            width={'50px'}
                            height={'50px'}
                            alt={'Bank Name'}
                            style={{ borderRadius: '8px 8px 8px 8px' }}
                        />
                    )}
                    <Box sx={{
                        // overflow: 'hidden',
                        // textOverflow: 'ellipsis',
                        // whiteSpace: 'nowrap',
                        // flexGrow: 1,
                    }}>
                        {isLoading ? (
                            <Skeleton variant="text" animation="wave" width={200} />
                        ) : (
                            <Typography variant="body_600" color="text.primary"
                                sx={{
                                    // textOverflow: 'ellipsis',
                                    // whiteSpace: 'nowrap',
                                    // overflow: 'hidden',
                                    maxWidth: '100%',
                                }}>
                                {' '}
                                {/* {data?.fundName || ''} */}
                                {values.fund[id].fundName || ''}
                            </Typography>
                        )}
                        {isLoading ? (
                            <Skeleton variant="text" animation="wave" width={200} />
                        ) : (
                            <Box display={'flex'} flexDirection={'row'} gap={'5px'}>
                                <Typography variant="body_500" color={palette.text.secondary}
                                    sx={{
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        maxWidth: '100%',
                                    }}>
                                    {/* {data?.fundType || ''} */}
                                    {values.fund[id].fundType || ''}
                                </Typography>
                                <Typography variant="body_500" color={palette.text.secondary}
                                    sx={{
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        maxWidth: '100%',
                                    }}>
                                    {/* • {data?.fundCap || ''} */}
                                    • {values.fund[id].fundCap || ''}
                                </Typography>
                                {/* {data?.riskType !== "NULL" && */}
                                {values.fund[id].riskType !== "NULL" &&
                                    <Typography variant="body_500" color={palette.success[500]}
                                        sx={{
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            maxWidth: '100%',
                                        }}>
                                        {/* • {data?.riskType || ''} */}
                                        • {values.fund[id].riskType || ''}
                                    </Typography>
                                }
                            </Box>
                        )}
                        {isLoading ? (
                            <Skeleton variant="text" animation="wave" width={200} />
                        ) : (
                            <Box sx={{ marginTop: "3px" }}>
                                <Typography
                                    variant="body_500"
                                    color="text.primary"
                                >
                                    ISIN:{' '}
                                    <Typography
                                        component="span"
                                        variant="body_500"
                                        color="text.secondary"
                                    >
                                        {values?.fund?.[id]?.isinCode ?? ''}
                                    </Typography>
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
                {isLoading ? (
                    <Skeleton variant="text" animation="wave" width={100} />
                ) :
                    <IconButton sx={{ display: 'flex', alignItems: 'center', gap: '5px' }} onClick={() =>
                        // handleDeleteCardValue(filterFolio?.id || data?.schemeId || '')}
                        handleDeleteCardValue(filterFolio?.id || values.fund[id].schemeId || '', values?.fund?.[id]?.uniqueId ?? '')}
                        disabled={isBankBalanceObjLoading}
                    >
                        <DeleteIcons />
                        <Hidden only={'xs'}>
                            <Typography variant="body_500" color={palette.error[500]}>
                                Remove
                            </Typography>
                        </Hidden>
                    </IconButton>
                }
            </Box>
            <Grid container >
                {/* <Hidden only={'xs'}> */}
                {(isLoading ? [1, 2, 3, 4] : investmentList)?.map((item: any, key) => (
                    <Grid item lg={3} md={6} sm={6} xs={12} key={key} sx={{
                        justifyContent: 'space-between',
                        display: 'flex',
                        flexDirection: { xs: 'row', sm: 'column', md: 'column', lg: 'column' },
                    }}>
                        {isLoading ? (
                            <Skeleton variant="text" animation="wave" width={100} />
                        ) : (
                            <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant="subtitle_400" color={palette.text.secondary} textTransform={'capitalize'}>
                                {item?.title}
                            </Typography>
                        )}

                        {isLoading ? (
                            <Skeleton variant="text" animation="wave" width={50} />
                        ) : (
                            <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant="body_500" fontWeight={600} color={palette.text.primary}>
                                {item?.value}
                            </Typography>
                        )}
                    </Grid>
                ))}
            </Grid>
            <TabContext value={field.value}>
                <Box
                    sx={{
                        borderBottom: `1px solid ${palette.text.secondary}99`,
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '10px',
                        paddingBottom: { lg: '0px', md: '0px', sm: '15px', xs: '15px' },
                    }}>
                    <TabList sx={{
                        '& .MuiTabs-indicator': {
                            display: 'none'
                        },
                        height: '40px',
                    }} aria-label="lab API tabs example" {...field} onChange={handleChange}>
                        {tabList.map((item, index) => (
                            <Tab label={<Typography variant='body_500' sx={(theme: Theme) => (
                                {
                                    color: field.value === item ? theme.palette.common.white : theme.palette.text.secondary,
                                    fontSize: '18px',
                                    textTransform: 'capitalize'
                                }
                            )}>{item}</Typography>}
                                disabled={isLoading || isSubmitting || isBankBalanceObjLoading}
                                sx={{
                                    borderRadius: { lg: '7px 7px 0px 0px', md: '7px 7px 0px 0px', sm: '7px', xs: '7px' },
                                    background: field.value === item ? palette.primary[500] : 'transparent',
                                    padding: '5px 15px',
                                    // cursor: isLoading ? 'not-allowed' : 'pointer',
                                    // opacity: isLoading ? 0.5 : 1,
                                }}
                                key={index} value={item} />
                            // <Box
                            //     key={index}
                            //     onClick={() => isLoading ? null : activeTab !== item && handleTabClick(item)}
                            //     sx={{
                            //         background: field.value === item ? palette.primary[500] : 'transparent',
                            //         borderRadius: { lg: '7px 7px 0px 0px', md: '7px 7px 0px 0px', sm: '7px', xs: '7px' },
                            //         padding: '5px 15px',
                            //         cursor: isLoading ? 'not-allowed' : 'pointer',
                            //         opacity: isLoading ? 0.5 : 1,
                            //     }}>
                            //     <Typography
                            //         color={field.value === item ? palette.textDark.primary : palette.text.secondary}
                            //         variant="body_500" fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>
                            //         {item}
                            //     </Typography>
                            // </Box>
                        ))}
                    </TabList>
                </Box>
                <Box>
                    {field.value === 'Lumpsum' ? (
                        <Lumpsum isLoading={isLoading} id={id} data={values.fund[id]} isSubmitting={isSubmitting || isBankBalanceObjLoading} bankAccountList={bankAccountList} />
                    ) : (
                        <Sip isLoading={isLoading} id={id} data={values.fund[id]} clientCode={clientCode} activeMandateList={activeMandateList}
                            // valueIdentifier={filterFolio?.id || data?.schemeId || ''}
                            valueIdentifier={filterFolio?.id || values.fund[id]?.schemeId || ''}
                            isSubmitting={isSubmitting || isBankBalanceObjLoading}
                            bankAccountList={bankAccountList}
                        />
                    )}
                </Box>
            </TabContext>
            {open && (
                <AlertModel
                    {...{
                        handleClose,
                        open,
                        setOpen,
                        setOpenBankModal,
                        title: 'No Mandates Available',
                        desc: 'There are currently no mandates available for completing your SIP transaction. In order to proceed with your investment, it is mandatory to have a mandate in place.',
                    }}
                />
            )}
            {openBankModal && (
                <AddBankModal
                    {...{
                        handleClose: handleBankClose,
                        handleSuccess: handleSuccess,
                        open: openBankModal,
                        setOpen: setOpenBankModal,
                        title: 'Add New Bank Mandate',
                        clientCode: clientCode,
                    }}
                />
            )}
        </Box>
    );
};

export default Card;